<template>
  <div class="container float-page">
    <!-- Float Box -->
    <div class="float-box">
      <div class="card">
        <!-- Float Card Body -->
        <div class="card-body float-card-body">
          <h1 class="mb-3">{{ $t('Customer.registerEmail.register') }}</h1>
          <p class="float-box-msg mb-2">
            {{ $t('Customer.forgotPassword.email') }}<br />
            {{ $t('Customer.forgotPassword.link') }}<br />
            {{ $t('Customer.forgotPassword.mailbox') }}
          </p>

          <el-form
            :model="registerEmailtModel"
            :rules="registerEmailRules"
            ref="registerEmailForm"
          >
            <el-form-item prop="emailOrName">
              <el-input
                v-model="registerEmailtModel.emailOrName"
                :placeholder="$t('Customer.forgotPassword.Electronic_mail')"
                suffix-icon="fas fa-envelope fa-sm"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button
            type="primary"
            class="btn btn-block btn-primary btn-lg email--send---success"
            @click="submit('registerEmailForm')"
          >
             {{ $t('Customer.registerEmail.submit') }}
          </el-button>
          <p class="text-center mt-5">
             {{ $t('Customer.forgotPassword.please') }}<a
              href="mailto:info@soonnet.org?subject=註冊會員時遇上問題&body=請說明您的問題，並留下相關註冊資訊（請不要透露密碼）："
              class="text-center"
              > {{ $t('Customer.forgotPassword.contact_us') }}</a
            >
          </p>
        </div>
        <!-- /.float-card-body -->
      </div>
    </div>
    <!-- /.float-box -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    /* 是否邮箱*/
    var isEmail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      if (value == "" || value == undefined || value == null) {
        callback(new Error(this.$t('Customer.forgotPassword.registerEmailRules.error1')));
      } else {
        if (value.indexOf("@") === -1) {
          callback(new Error(this.$t('Customer.forgotPassword.registerEmailRules.error2')));
        } else {
          callback();
        }
      }
    };
    return {
      registerEmailtModel: {
        emailOrName: "",
      },
      registerEmailRules: {
        emailOrName: [{ required: true, validator: isEmail, trigger: "blur" }],
      },
    };
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
  },
   watch: {

        },
  methods: {

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            email: this.registerEmailtModel.emailOrName,
          };
          //發送請求查詢是否存在賬戶
          this.$api.common.checkEmail(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "發送成功",
              });
              //发送邮件 用户通过邮箱链接进行注册

              //若無此賬戶則跳轉至登錄頁面
              // this.$router.push({ name: "customerRegist" });
            } else {
              Message({
                type: "error",
                message: res.data.error.message,
              });
            }
          });
        } else {
          Message({
            type: "error",
            message: "請輸入用戶名或郵箱",
          });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Customer/registerEmail.vue